import type { TDatadogErrorLog } from 'utils/datadog/types'

export const GROUP_NICHES_LOG: TDatadogErrorLog = {
  from: 'src/modules/niche/group-niches-form/index.ts',
  name: 'Groups niches',
  message: 'Groups a list of niches into a new one',
}
